module.exports = __webpack_public_path__ + "static/img/foot.5d962564.png";